module.exports = __webpack_public_path__ + "img/fangdian.74c00634.png";